var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 100,
    viewBox: "0 0 158 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.443 71.36L107.803 72.93L115.333 81.63C116.523 83.01 117.613 84.47 118.723 85.92C122.053 90.26 127.233 92.86 132.783 92.86H133.133C144.643 92.86 153.103 82.05 150.323 70.87L134.013 20.44C132.053 12.54 124.963 7 116.823 7H41.0328C32.8928 7 25.8128 12.54 23.8428 20.44L7.53277 70.88C4.75277 82.05 13.2028 92.87 24.7228 92.87C30.4328 92.87 35.7528 90.12 39.0528 85.56C40.2728 83.87 41.4528 82.16 42.7328 80.51L54.9828 64.77C57.9128 60.78 61.6528 58.07 66.3828 58.07H87.0828C91.8128 58.07 96.1728 55.51 98.4828 51.38L105.443 40.37",
    stroke: "url(#paint0_angular_62_2)",
    strokeWidth: 13.73,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2028 35.62L115.323 53.3L113.193 30.02C113.033 28.23 111.993 28.17 110.323 28.69L88.1927 35.63L88.2028 35.62Z",
    fill: "#5800C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_62_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.133 40.48) rotate(117.951) scale(110.941 185.856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5007BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A900E9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.c6793015a8d67b3df391965c4b242cde.svg";
export { ForwardRef as ReactComponent };